import { render } from "./resource_center.vue?vue&type=template&id=52824b72&scoped=true"
import script from "./resource_center.vue?vue&type=script&lang=js"
export * from "./resource_center.vue?vue&type=script&lang=js"

import "./resource_center.vue?vue&type=style&index=0&id=52824b72&scoped=true&lang=css"

import exportComponent from "/root/workspace/yatinjuryplatformwebcode_Vf1x/CODE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52824b72"]])

export default __exports__